// Import files here. This is the main lib entry point.
// You can use ES5, or ES6 here.
import $ from "jquery";
const jQuery = $;

$(document).on("click", 'a[rel$="external"]', function () {
    $(this).attr("target", "_blank");
});

$(document).on("click", 'a[href$=".pdf"]', function () {
    $(this).attr("target", "_blank");
});

$("a").each(function () {
    var a = new RegExp("/" + window.location.host + "/");
    if (!a.test(this.href)) {
        $(this).click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, "_blank");
        });
    }
});

jQuery.fn.extend({
    live: function (event, callback) {
        if (this.selector) {
            jQuery(document).on(event, this.selector, callback);
        }
    },
});

$(".nav-links").click(function (e) {
    anchorScroll(
        $(this),
        $($(this).attr("href")),
        1200,
        $("#header").get(0).getBoundingClientRect().height
    );
});

function anchorScroll(this_obj, that_obj, base_speed, offset) {
    var this_offset = this_obj.offset();
    var that_offset = that_obj.offset();
    var offset_diff = Math.abs(that_offset.top - this_offset.top);

    var speed = (offset_diff * base_speed) / 2000;

    $("html,body").animate(
        {
            scrollTop: that_offset.top - offset,
        },
        speed
    );
}

$('[data-element-name="content"] img.remdiv').unwrap("p");

//DISALBES form submit on enter
$("#searchform").on("keyup keypress", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

//adds new window label for screen readers

$("a[target='_blank']").each(function (e) {
    var el = $(this);
    if (el.text() !== "") {
        el.attr("aria-label", el.text() + " - New Window");
    }
});



$(document).ready(function () {
    $("#bs4navbar .nav-link").click(function (e) {
        if (!!e.originalEvent) {
            if (e.originalEvent instanceof MouseEvent) {
                var url = $(this).attr("href");
                $(location).attr("href", url);
            }
        }
    });
});

jQuery(document).ready(function() {
    jQuery('p').each(function() {
        var $this = jQuery(this);
        if($this.html().replace(/\s|&nbsp;/g, '').length == 0) {
            $this.remove();
        }
    });



const words = document.querySelectorAll('.word');
  const interval = 2000; // 1 second

  function animateWords() {
    let delay = 0;
    words.forEach((word, index) => {
      setTimeout(() => {
        word.classList.add('animated');
      }, delay);
      delay += interval;
    });
  }

  function resetAnimation() {
    words.forEach((word) => {
      word.classList.remove('animated');
    });
    setTimeout(animateWords, interval);
  }

  animateWords();
  setInterval(resetAnimation, interval * words.length);


});
$(document).ready(function() {
// Hide all boxes except the first one
$(".box:not(:first)").hide();

function showNextBox() {
    var currentBox = $(".box:visible");
    var nextBox = currentBox.next(".box").length ? currentBox.next(".box") : $(".box:first");

    currentBox.fadeOut(500, function() {
    nextBox.fadeIn(500);
    });
}

// Start the loop with a delay of 2000ms (2 seconds)
setInterval(showNextBox, 3000);
});